import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Screenshot from '@hydra/common/components/Screenshot';
import { useReviewContext } from '@hydra/common/context/review';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  }
}));

export const CriteriumScreenshots = ({ phone, tablet }) => {
  const { isPdf } = useReviewContext();
  const classes = useStyles();
  if (!phone && !tablet) {
    return null;
  }
  return (
    <div className={classes.root}>
      {phone ? <Screenshot type='phone' src={phone} width={86} height={152} defer={!isPdf} /> : null}
      {tablet ? <Screenshot type='tablet' src={tablet} width={240} height={172} defer={!isPdf} /> : null}
    </div>
  );
};

CriteriumScreenshots.propTypes = {
  tablet: PropTypes.string,
  phone: PropTypes.string
};

export default CriteriumScreenshots;
